export const TAG_NAME_MAX_LENGTH = 20;

export type TagNameError = 'required' | 'maxLength' | 'duplicate';

type ExistingTag = { readonly id: string; readonly name: string };

export const validateTagName = (
  tags: readonly ExistingTag[],
  name: string,
  excludeId?: string,
): TagNameError | null => {
  const trimmed = name.trim();
  if (trimmed.length === 0) return 'required';
  if (trimmed.length > TAG_NAME_MAX_LENGTH) return 'maxLength';
  if (tags.some((tag) => tag.name === trimmed && tag.id !== excludeId)) return 'duplicate';
  return null;
};
